<template>
    <div>
        <div name="table-list" class="table-layout" v-if="paramMap != null && showTab">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="型号备选" name="first" v-if="showDevice">
                    <swb-easy-report-table :confKey="confKey" :configAuto="true" :reportName="'工单指派调度策略【指派服务商-型号备选】'" :reportCode="'servc_work_voucher_dispatch_strategy_assign_servicer_device'" :paramMap="paramMap" :paramKeys="[]" :hideParamKeys="hideParamKeys" :showStatColumns="false" :queryData="true" :domHeight="domHeight" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :actionsRenderFuncs="actionsRenderFuncs" :actionsHandlerFuncs="actionsHandlerFuncs" :showExport="false"></swb-easy-report-table>
                </el-tab-pane>
                <el-tab-pane label="同专业" name="second" v-if="showDevcgroup">
                    <swb-easy-report-table :confKey="confKey" :configAuto="true" :reportName="'工单指派调度策略【指派服务商-同专业备选】'" :reportCode="'servc_work_voucher_dispatch_strategy_assign_servicer_devc_group'" :paramMap="paramMap" :paramKeys="[]" :hideParamKeys="hideParamKeys" :showStatColumns="false" :queryData="true" :domHeight="domHeight" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :actionsRenderFuncs="actionsRenderFuncs" :actionsHandlerFuncs="actionsHandlerFuncs" :showExport="false"></swb-easy-report-table>
                </el-tab-pane>
                <el-tab-pane label="常规服务备选" name="third" v-if="showComnRepair">
                    <swb-easy-report-table :confKey="confKey" :configAuto="true" :reportName="'工单指派调度策略【指派服务商-常规服务备选】'" :reportCode="'servc_work_voucher_dispatch_strategy_assign_servicer_comn_repair'" :paramMap="paramMap" :paramKeys="[]" :hideParamKeys="hideParamKeys" :showStatColumns="false" :queryData="true" :domHeight="domHeight" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :actionsRenderFuncs="actionsRenderFuncs" :actionsHandlerFuncs="actionsHandlerFuncs" :showExport="false"></swb-easy-report-table>
                </el-tab-pane>
                <el-tab-pane label="全部" name="fourth" v-if="showBizRel"></el-tab-pane>
            </el-tabs>
        </div>
        <swb-easy-report-table v-if="activeName == 'fourth'" :confKey="confKey" :configAuto="true" :reportName="'工单指派调度策略【指派服务商-商户关系备选】'" :reportCode="'servc_work_voucher_dispatch_strategy_assign_servicer_biz_rel'" :paramMap="paramMap" :paramKeys="[]" :hideParamKeys="hideParamKeys" :showStatColumns="false" :queryData="true" :domHeight="domHeight" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :actionsRenderFuncs="actionsRenderFuncs" :actionsHandlerFuncs="actionsHandlerFuncs" :showExport="false"></swb-easy-report-table>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import SwbEasyReport from './EasyReport'
    Vue.regist(SwbEasyReport);

    export default {
        name: 'swb-servc-work-voucher-ds-assign-servicer-select',
        desc: '工单指派调度策略【指派服务商】',
        props: ['showDevice', 'showDevcgroup', 'showComnRepair', 'showBizRel', 'assign', 'deviceId', 'servcType', 'repairId'],
        data: function () {
            return {
                confKey: 'swb-servc-work-voucher-ds-assign-servicer-select',
                domHeight: 550,
                paramMap: null,
                hideParamKeys: ["retailerId", "cxtMerchantId", "cxtMerchantIdX", "deviceId", "servcType", "repairId"],
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 100,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                activeName: 'first',
                showTab: true
            }
        },
        created: function () {
            this.paramMap = {
                deviceId: this.deviceId,
                servcType: this.servcType,
                repairId: this.repairId
            };
            if(Utils.isNoB(this.deviceId)) {
                if(!Utils.isNoB(this.repairId)) {
                    this.activeName = 'third';
                } else {
                    this.showTab = false;
                    this.activeName = 'fourth';
                }
            }
        },
        methods: {
            handleClick(){

            },
            actionsRenderFuncs(row, colName, colValue, rowIndex){
                return '<a name="assign" class="swb-btn swb-btn-link">指派</a>';
            },
            actionsHandlerFuncs(row, colName, colValue, rowIndex, btnName){
                if(btnName == 'assign') {
                    this.assign(row);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/easyReport/ServcWorkVoucherDsAssignServicerSelect.vue